import React, { useState } from "react";
import { isIOS, isMacOs } from "react-device-detect";
import { useTranslation } from "react-i18next";

import { Button, Text } from "/component/base";
import { Alert } from "/component/base/Icon";
import { useSystemMessageModal } from "/hook";

import {
  Body,
  Content,
  IconContainer,
  Link,
  Modal,
  Overlay,
  TextGroup,
  Title,
} from "./SystemMessageModal.styles";
import { SystemMessageModalKey } from "./SystemMessageModal.types";

const ATHENA_PORTAL_URL = "https://www.summithealth.com/patient-portal";
const ATHENA_MOBILE_APP_URL =
  isIOS || isMacOs
    ? "https://apps.apple.com/us/app/athenapatient/id1644169294"
    : "https://play.google.com/store/apps/details?id=com.athenahealth.athenapatient";

const SystemMessageModal = () => {
  const { t } = useTranslation("modal-SystemMessageModal");
  const { enabled } = useSystemMessageModal();
  const [showModal, setShowModal] = useState(() => {
    const saved = localStorage.getItem(SystemMessageModalKey);

    // If it's never been set, this is a new user/device
    if (saved === null) {
      localStorage.setItem(SystemMessageModalKey, "true");
      return true;
    }

    return JSON.parse(saved);
  });

  const handleClose = () => {
    setShowModal(false);
    localStorage.setItem(SystemMessageModalKey, "false");
  };

  if (!showModal || enabled) return null;

  return (
    <Modal
      modalBody={Body}
      overlay={<Overlay />}
      key={SystemMessageModalKey}
      isOpen={showModal}
      close={handleClose}
    >
      <Content>
        <IconContainer>
          <Alert size={28} />
        </IconContainer>
        <Title variant="title3">{t("title")}</Title>
        <TextGroup>
          <Text>{t("body")}</Text>
          <Link href={ATHENA_PORTAL_URL}>{t("athenaPortalLinkText")}</Link>
          <Text>{t("or")}</Text>
          <Link href={ATHENA_MOBILE_APP_URL}>{t("mobileAppLinkText")}</Link>
          {t("bodyEnd")}
        </TextGroup>
        <Button onClick={handleClose}>{t("okay")}</Button>
      </Content>
    </Modal>
  );
};

export default SystemMessageModal;
